module.exports = __webpack_public_path__ + "img/personal_student_wrong_explain_active.df822c49.svg";